import React from 'react';
import { Link } from 'react-router-dom';

/** Shown on home when the catalog loaded but has no products yet (not a fetch error). */
export default function HomeShopEmptyStrip({ store, whatsappHref }) {
  return (
    <section className="home-shop-empty" role="status">
      <div className="container store-page__container">
        <div className="home-shop-empty__panel">
          <h2 className="home-shop-empty__title h5">{store.home_shop_empty_title}</h2>
          <p className="home-shop-empty__text mb-0">{store.home_shop_empty_text}</p>
          <div className="home-shop-empty__actions">
            <Link to="/shop" className="btn btn-primary btn-sm rounded-pill store-cta">
              {store.home_shop_empty_action}
            </Link>
            <Link to="/exhibitions" className="btn btn-outline-secondary btn-sm rounded-pill">
              Exhibitions
            </Link>
            {whatsappHref ? (
              <a
                href={whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-secondary btn-sm rounded-pill"
              >
                WhatsApp us
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}
